import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideProjectOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="プロジェクト管理"
      description="プロジェクトの登録・更新・ステータス管理を行う機能です。取引先・マネージャーとの紐付けやステータス遷移を管理します。管理者・管理部門・課長が操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="project/register">新規プロジェクトを登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              新しいプロジェクトを登録し、取引先・マネージャーを紐付けます。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="project/bulk-register">プロジェクトを一括登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              CSVファイルを使用して複数のプロジェクトを一括で登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="project/update">プロジェクト情報を更新する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存プロジェクトの情報やステータスを更新します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="project/detail">プロジェクトの詳細情報を確認する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              プロジェクトの登録情報を詳細画面で確認します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="project/search">プロジェクトを検索する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              条件を指定してプロジェクトを検索・絞り込みます。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideProjectOverview;
